import { getSupportReportThread, postSupportReportThreadMessage } from '../../api/supportApi';

/**
 * Canonical thread API: GET/POST /api/v2/reports/{id}/thread
 * Kept as a thin adapter so ThreadView / useThread stay unchanged.
 */
export const getThreadMessages = async (reportId) => {
  const data = await getSupportReportThread(reportId);
  return Array.isArray(data) ? data : [];
};

export const postThreadMessage = async (reportId, messageData) => {
  const payload = typeof messageData === 'string' ? { message: messageData } : messageData;
  return postSupportReportThreadMessage(reportId, payload);
};
